import { useEffect, useRef } from 'react';
import { useGameStore } from '../store/game-store.ts';
import { fetchOnboarding, postOnboarding } from '../api/onboarding.ts';

/**
 * Keeps the server-tracked guide state in the store, so the guide panel and the contextual hints
 * in the other panels read the same thing. Game state changes (live pushes update fleets, map and
 * resources) re-read the milestones; opening the home system reports the first step.
 */
export function useOnboardingSync(homeSystemId: string): void {
  const { fleets, galaxyMap, resources, selectedSystemId, onboarding, setOnboarding } = useGameStore();
  const reportedHome = useRef(false);

  useEffect(() => {
    const t = setTimeout(() => { fetchOnboarding().then(setOnboarding).catch(() => undefined); }, 400);
    return () => clearTimeout(t);
  }, [fleets, galaxyMap, resources, setOnboarding]);

  useEffect(() => {
    if (selectedSystemId !== homeSystemId || reportedHome.current || !onboarding || onboarding.steps[0]?.done) return;
    reportedHome.current = true;
    postOnboarding('home_viewed').then(setOnboarding).catch(() => { reportedHome.current = false; });
  }, [selectedSystemId, homeSystemId, onboarding, setOnboarding]);
}
